<template>
  <div class="content">
    <div v-for="(c,i) in code" :key="'code'+i"
      class="icon">
      <img :src="icon[c['@call']]" />
    </div>
  </div>
</template>

<script>
import { default as Cmd , iconKey } from './mixin-cmd'
export default {
  computed: {
    icon () { return iconKey },
    code () { return this.innerValue.code }
  },
  props: {
    value: Object,
  },
  mixins: [ Cmd ],
  data () {
    return {
      innerValue: this.value,
    }
  },
  watch: {
    innerValue (v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  display: flex;
}
.icon {
  width: 32px;
  height: 32px;
}
</style>